"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { For } from "react-haiku";

const links = [
  {
    href: "/case-studies/miles-trembly",
    label: "Miles",
  },
  {
    href: "/case-studies/dori-wispletter",
    label: "Dori",
  },
  {
    href: "/case-studies/sebastien-thrump",
    label: "Sebastien",
  },
  {
    href: "/case-studies/claudes-toupei",
    label: "Claudes",
  },
  {
    href: "/case-studies/flora-greenleaf",
    label: "Flora",
  },
  {
    href: "/case-studies/fred-comenski",
    label: "Fred",
  },
  {
    href: "/case-studies/betty-lou-mercury",
    label: "Betty Lou",
  },
  {
    href: "/case-studies/morticulus-fumebumm",
    label: "Morti",
  },
];

export default function Nav() {
  const pathname = usePathname();
  return (
    <div className="flex gap-8 sm:gap-4 justify-between border-b py-6 px-10 lg:px-20 overflow-auto">
      <For
        each={links}
        render={({ href, label }) => (
          <Link
            href={href}
            className={`text-2xl hover:border-b-black border-b-[5px] whitespace-nowrap transition-all duration-200 ease-in-out pb-2 ${pathname === href ? "font-bold border-b-black" : "border-b-transparent "}`}
          >
            {label}
          </Link>
        )}
      />
    </div>
  );
}
